export const easeLinear = percentComplete => {
    return percentComplete;
};

export const easeOutSine = percentComplete => {
    return Math.sin((percentComplete * Math.PI) / 2);
};

export const easeInSine = percentComplete => {
    return 1 - Math.cos((percentComplete * Math.PI) / 2);
};

export const animateScrollTo = (x, y, element, callback = null, duration = 200, easeFunc = easeInSine) => {
    if (element.scrollLeft == x && element.scrollTop == y) {
        if (callback) {
            callback();
        }
        return;
    }

    let oldTimestamp = null;
    let stepXDistance = 0;
    let stepYDistance = 0;

    let totalScrollXDistance = x - element.scrollLeft;
    let totalScrollYDistance = y - element.scrollTop;

    const scrollXDir = totalScrollXDistance >= 0 ? 'right' : 'left';
    const scrollYDir = totalScrollYDistance >= 0 ? 'down' : 'up';
    totalScrollXDistance = Math.abs(totalScrollXDistance);
    totalScrollYDistance = Math.abs(totalScrollYDistance);

    const originalScrollLeft = element.scrollLeft;
    const originalScrollTop = element.scrollTop;

    const step = newTimestamp => {
        if (oldTimestamp) {
            let percentComplete = (newTimestamp - oldTimestamp) / duration;

            if (percentComplete > 1) {
                percentComplete = 1;
            }

            const stepFactor = easeFunc(percentComplete);

            stepXDistance = totalScrollXDistance * stepFactor;
            if (scrollXDir == 'left') {
                stepXDistance *= -1;
            }

            stepYDistance = totalScrollYDistance * stepFactor;
            if (scrollYDir == 'up') {
                stepYDistance *= -1;
            }

            element.scrollLeft = originalScrollLeft + stepXDistance;
            element.scrollTop = originalScrollTop + stepYDistance;

            if (percentComplete == 1) {
                if (callback) {
                    callback();
                }
                return;
            }
        } else {
            oldTimestamp = newTimestamp;
        }
        window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
};

export const animateFixedMoveTo = (x, y, element, callback = null, duration = 200, easeFunc = easeInSine) => {
    if (element.left == x && element.top == y) {
        if (callback) {
            callback();
        }
        return;
    }

    const bounds = element.getBoundingClientRect();

    let totalMoveXDistance = x - bounds.left;
    let totalMoveYDistance = y - bounds.top;

    const moveXDir = totalMoveXDistance >= 0 ? 'right' : 'left';
    const moveYDir = totalMoveYDistance >= 0 ? 'down' : 'up';

    totalMoveXDistance = Math.abs(totalMoveXDistance);
    totalMoveYDistance = Math.abs(totalMoveYDistance);

    const originalLeft = bounds.left;
    const originalTop = bounds.top;

    let oldTimestamp = null;
    let stepXDistance = 0;
    let stepYDistance = 0;

    const step = newTimestamp => {
        if (oldTimestamp !== null) {
            let percentComplete = (newTimestamp - oldTimestamp) / duration;

            if (percentComplete > 1) {
                percentComplete = 1;
            }

            stepXDistance = totalMoveXDistance * easeFunc(percentComplete);
            if (moveXDir == 'left') {
                stepXDistance *= -1;
            }

            stepYDistance = totalMoveYDistance * easeFunc(percentComplete);
            if (moveYDir == 'up') {
                stepYDistance *= -1;
            }

            if (x != 'auto') {
                element.style.left = `${originalLeft + stepXDistance}px`;
            }

            if (y != 'auto') {
                element.style.top = `${originalTop + stepYDistance}px`;
            }

            if (percentComplete == 1) {
                if (callback) {
                    callback();
                }
                return;
            }
        } else {
            oldTimestamp = newTimestamp;
        }
        window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
};

